import { action } from "../common/Action"
import { BaseUrl } from "../BaseClient"
import { AttachmentsClient, AttachmentDto } from "../generated";
import type { FileParameter } from "../generated";

const service = new AttachmentsClient();

export class AttachmentsActions {

    @action
    get(folder: string, subfolder: string) {
        return service.get(folder, subfolder)
            .then(result => ({ resourceName: folder, resourceId: subfolder, data: result }));
    }

    @action
    async preview(fileKey: string) {
        return service.preview(fileKey)
            .then(result => ({ fileKey, result }));
    }

    @action
    async upload(folder: string, subfolder: string, file: FileParameter) {
        return uploadDocument(folder, subfolder, file.data)
            .then(result => ({ folder, subfolder, data: result }));
    }

    @action
    async download(fileId: string) {
        return download(fileId);
    }

    @action
    async delete(fileId: string) {
        return await service.deleteDocument(fileId).then(result => ({ resourceName: result!.folderName, resourceId: result!.subfolderName, key: result!.key }));
    }
}


function uploadDocument(folderName: string | null, subfolderName: string | null, file: File) {
    const formData = new FormData();
    formData.append("file", file)
    return (upload(`${BaseUrl}/attachments/upload?folderName=${folderName ?? ''}&subfolderName=${subfolderName ?? ''}`, formData) as Promise<AttachmentDto>)
        ;
}
function download(fileKey: string | null) {
    return (get(`${BaseUrl}/attachments/download?fileKey=${fileKey ?? ''}`));
}

export function requestAndDownloadIfNeccessary(url: string) {
    return get(url);
}

function get<T>(url: string): Promise<T> {
    return fetch(url, createRequest("get"))
        .then(parseResponse)
        .then(parseStatusCode);
}

function createRequest(method: string, data?: Object): RequestInit {
    return {
        credentials: "include",
        method: method,
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            'charset': 'utf8',
        } as any,
        body: data !== undefined ? JSON.stringify(data) : undefined
    };
}

function createUploadRequest(method: string, data: FormData): RequestInit {
    return {
        credentials: "include",
        method: method,
        mode: "cors",
        body: data
    };
}

function upload(url: string, file: FormData) {
    return fetch(url, createUploadRequest("post", file))
        .then(parseResponse)
        .then(parseStatusCode);
}



const parseResponse = (response: Response) => {
    let cd = response.headers.get("Content-Disposition");
    if (cd && cd.indexOf("attachment") != -1) {
        var regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var match = regex.exec(cd);
        var fileName = match && match[1] || "file";
        fileName = fileName.replace(/\"/g, "");
        try {
            response.clone().blob().then(data => {
                //@ts-ignore
                import("file-saver")
                    .then(instance => {
                        instance.default.saveAs(data, fileName)
                    });
            });
        } catch (exc) {
            console.log("Save Blob method failed with the following exception.");
            console.log(exc);
        }
    }

    var promises = [Promise.resolve(response.status), response.text().then(txt => {
        if (!txt || txt === "")
            return null;

        try {
            return JSON.parse(txt);
        } catch (e) {
            return txt;
        }
    })];
    return Promise.all(promises)
}

function parseStatusCode(results: Array<any>) {
    var statusCode = results[0];
    if (statusCode === 200 || statusCode === 304 || statusCode === 204)
        return results[1];
    else {
        results[1].statusCode = statusCode;
        return Promise.reject(results[1]);
    }
}
export default new AttachmentsActions();